<!--
 * @Author: xiaoxi 2767862556@qq.com
 * @Date: 2022-06-26 22:32:21
 * @LastEditors: xiaoxi 2767862556@qq.com
 * @LastEditTime: 2022-06-26 22:33:39
 * @FilePath: \webpatient\src\views\hospitalPhysicalTeamExam\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <Common>
      <template slot="sz">
          <SzhospitalTeamExam />
      </template>
    </Common>
</template>

<script>
import SzhospitalTeamExam from "@/components/hospitalPhysicalTeamExam/szhospitalTeamExam"
export default{
  components:{
    SzhospitalTeamExam
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>